import { Button } from '@/components/ui/button';
import Link from 'next/link';
import { ArrowRight } from 'lucide-react';

export function CTASection() {
	return (
		<section className="py-20 bg-gradient-to-r from-emerald-600 to-green-700 text-white">
			<div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
				<h2 className="text-3xl md:text-4xl font-bold mb-4">
					Ready to Boost your Deliverability?
				</h2>
				<p className="text-xl text-emerald-100 mb-8">
					Join the modern sales teams improving deliverability by 15-30% with NOS Email
				</p>
				<div className="flex justify-center">
					<Link
						href="/signup"
						className="bg-white text-emerald-600 hover:bg-gray-50 px-8 py-3 text-lg font-medium rounded-lg transition-colors flex items-center gap-2"
					>
						Get Started
						<ArrowRight className="h-5 w-5" />
					</Link>
				</div>
			</div>
		</section>
	);
}
